var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2725 16.1072L45.1262 11.1616V6.97808H50.2725V16.1072ZM65.0289 30.2846L53.6593 19.3597V5.98309C53.6593 4.64595 52.5853 3.55861 51.2649 3.55861H43.8946C42.7065 3.55861 41.7405 4.53785 41.7405 5.73855V7.90799L34.4252 0.880127C34.0009 0.472897 33.4434 0.248291 32.8593 0.248291C32.2742 0.248291 31.7177 0.472897 31.2934 0.880127L0.691826 30.2836C0.0220892 30.9238 -0.01071 32.0017 0.616706 32.685C0.936233 33.0324 1.38696 33.2307 1.85672 33.2307C2.29369 33.2307 2.70844 33.0628 3.0248 32.7595L32.8593 4.09493L62.6938 32.7584C63.0091 33.0628 63.4249 33.2307 63.8608 33.2307C64.3306 33.2307 64.7824 33.0324 65.103 32.685C65.7283 32.0028 65.6965 30.9249 65.0289 30.2846Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9921 63.4667H25.0215V39.1976C25.0215 39.0886 25.1128 38.9976 25.221 38.9976H39.7926C39.9008 38.9976 39.9921 39.0886 39.9921 39.1976V63.4667ZM55.8626 63.4667H43.3804V39.1976C43.3804 37.2015 41.7739 35.5811 39.7926 35.5811H25.221C23.2396 35.5811 21.6332 37.2015 21.6332 39.1976V63.4667H9.15096V26.9149H5.79102V64.0678C5.79102 65.6406 7.0552 66.9149 8.61442 66.9149H56.3992C57.9594 66.9149 59.2236 65.6406 59.2236 64.0678V26.9149H55.8626V63.4667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.724a89fa56777f2cfe2be9751fe80a63.svg";
export { ForwardRef as ReactComponent };